import { combineReducers } from 'redux';

import createReducer from '../../services/create-reducer';
import {
  SET_PAGE_LAYOUT,
  SET_IS_LOADING,
  CLEAR_MEMBERS,
  SET_METADATA,
  SET_MEMBER_IDS,
  SET_MEMBERS_BADGE_ID_FILTER,
  MEMBERS_SEARCH,
  MEMBERS_SORT,
  MEMBERS_FILTER,
  REMOVE_MEMBER_FROM_LIST,
  LAST_MEMBER_FETCH_SOURCE,
} from './actions';
import { MEMBERS_PER_PAGE, DEFAULT_SORT, DEFAULT_FILTER } from '../../constants/pagination';

const metadata = createReducer(
  { count: MEMBERS_PER_PAGE, page: 1 },
  {
    [SET_METADATA]: (a) => a.payload,
    [REMOVE_MEMBER_FROM_LIST]: (_a, prev) => ({ ...prev, count: prev.count - 1 }),
  },
);

const pageLayout = createReducer(null, {
  [SET_PAGE_LAYOUT]: (a) => a.payload,
});

const idList = createReducer([], {
  [SET_MEMBER_IDS]: (resp, prev) => prev.concat(resp.payload),
  [CLEAR_MEMBERS]: () => [],
  [REMOVE_MEMBER_FROM_LIST]: (resp, prev) => prev.filter((a) => a !== resp.payload),
});

const isLoading = createReducer(false, {
  [SET_IS_LOADING]: (a) => a.payload,
});

const sort = createReducer(DEFAULT_SORT, {
  [MEMBERS_SORT]: (a) => a.payload,
});

const search = createReducer(null, {
  [MEMBERS_SEARCH]: (a) => a.payload,
});

const filter = createReducer(DEFAULT_FILTER, {
  [MEMBERS_FILTER]: (a) => a.payload,
});

const badgeId = createReducer(null, {
  [SET_MEMBERS_BADGE_ID_FILTER]: (a) => a.payload,
});

const lastMemberFetchSource = createReducer(null, {
  [LAST_MEMBER_FETCH_SOURCE]: (a) => a.payload,
});

export default combineReducers({
  metadata,
  pageLayout,
  idList,
  isLoading,
  sort,
  search,
  filter,
  badgeId,
  lastMemberFetchSource,
});
